import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

/**
 * Mini 3×3 grid loader (center cell removed, clockwise sweep).
 * Drop-in replacement for circular Loader2 spinners.
 * Uses `currentColor` so color inherits from parent text-* classes.
 * Accepts the same sizing classes as Loader2 (e.g. h-4 w-4).
 */

const CLOCKWISE_ORDER = [0, 1, 2, 5, 8, 7, 6, 3];

interface MiniGridLoaderProps {
  className?: string;
}

const MiniGridLoader: React.FC<MiniGridLoaderProps> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <div
      className={cn('grid grid-cols-3 gap-[1px] flex-shrink-0', className)}
      role="status"
      aria-label={t('common.loading', 'Loading')}
    >
    {Array.from({ length: 9 }, (_, pos) => {
      if (pos === 4) return <div key={pos} />;
      return (
        <div
          key={pos}
          className="rounded-[1px] animate-grid-pulse"
          style={{
            backgroundColor: 'currentColor',
            animationDelay: `${CLOCKWISE_ORDER.indexOf(pos) * 125}ms`,
          }}
        />
      );
    })}
  </div>
  );
};
export default MiniGridLoader;
